import React from 'react';
import PropTypes from 'prop-types';
import { Col, Panel, Row } from 'react-bootstrap-5';
import { connect } from 'react-redux';
import filter from 'lodash/filter';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';

import CopyConnectInfoModal from './copy_connect_info_modal';
import ConnectableRow from './connections/connectable_row';
import { copyAndConnect, connectEntities, unlink, togglePageFlag } from '../actions/index';
import { logOneOffEvent } from 'helpers/one_off_events';

export class ConnectionList extends React.Component {
  static propTypes = {
    availableDatabaseOptions: PropTypes.array.isRequired,
    connectableObjects: PropTypes.arrayOf(PropTypes.shape({
      connections: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired
      })),
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    })).isRequired,
    firstVisit: PropTypes.bool,
    togglePageFlag: PropTypes.func.isRequired,
    onConnectEntities: PropTypes.func.isRequired,
    onCopyAndConnect: PropTypes.func.isRequired,
    onUnlink: PropTypes.func.isRequired
  }

  state = {
    showInfoModal: this.props.firstVisit || false
  }

  componentDidMount() {
    if (this.props.firstVisit) {
      logOneOffEvent('view_project_connection_list');
      this.props.togglePageFlag('connectionList');
    }
  }

  showInfoModal = (e) => {
    if (e) e.preventDefault();

    this.setState({ showInfoModal: true });
  }

  hideInfoModal = () => {
    this.setState({ showInfoModal: false });
  }

  connectedObjects() {
    return filter(this.props.connectableObjects, obj => obj.connections.length !== 0);
  }

  unconnectedObjects() {
    return filter(this.props.connectableObjects, obj => obj.connections.length === 0);
  }

  renderDetails({ name, subtitle }) {
    return (
      <React.Fragment>
        <div>
          <strong>{name}</strong>
        </div>
        <div>{subtitle}</div>
      </React.Fragment>
    );
  }

  renderUnconnected() {
    const unconnected =
      this.unconnectedObjects().map(connectableObject => this.renderConnectableRow(connectableObject));

    if (unconnected.length === 0) {
      return;
    }

    return (
      <React.Fragment>
        <h6 className="mt-5 mb-2">
          <FontAwesomeIcon icon={faInfoCircle}/>
          <span className="ms-3">Unlinked ({unconnected.length})</span>
        </h6>
        <p className="text-muted">
          Add these contacts and properties to a database.  Once linked you will be able to associate the property
          or contact on tasks and decide where you want the activity to show up.&nbsp;
          <span className="text-danger">
            Some contacts or properties may already exist in your database, however you will still need to link them to
            create a project link.
          </span>
        </p>
        <hr/>
        <div name="unconnectedList">
          {unconnected}
        </div>
      </React.Fragment>
    );
  }

  renderConnected() {
    const connected = this.connectedObjects().map(connectableObject => this.renderConnectableRow(connectableObject));

    if (connected.length === 0) {
      return;
    }

    return (
      <React.Fragment>
        <h6 className="mt-5 mb-2">
          <FontAwesomeIcon icon={faInfoCircle}/>
          <span className="ms-3">Successfully linked ({connected.length})</span>
        </h6>
        <p className="text-muted">
          These are your existing database links.
          Add them as associations to any activity you want to populate in your database.
        </p>
        <hr/>
        <div name="connectedList">
          {connected}
        </div>
      </React.Fragment>
    );
  }

  renderConnectableRow = (connectableObject) => {
    return (
      <ConnectableRow
        availableDatabaseOptions={this.props.availableDatabaseOptions}
        connectableObject={connectableObject}
        key={connectableObject.id}
        onConnectEntities={this.props.onConnectEntities}
        onCopyAndConnect={this.props.onCopyAndConnect}
        onUnlink={this.props.onUnlink}
      />
    );
  }

  renderHeading() {
    return (
      <Row className="align-items-center">
        <Col><h5>Database Links</h5></Col>
        <Col xs="auto">
          <a className="text-right small" href="#" onClick={this.showInfoModal}>
            <FontAwesomeIcon className="me-1" icon={faQuestionCircle} />
            <b>Learn more about Database Links</b>
          </a>
        </Col>
      </Row>
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className="mb-4">
          {this.renderHeading()}
        </div>
        {this.renderUnconnected()}
        {this.renderConnected()}
        <CopyConnectInfoModal show={this.state.showInfoModal} onHide={this.hideInfoModal} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ connectableObjects, availableDatabaseOptions, pageFlags }) => {
  return { connectableObjects, availableDatabaseOptions, firstVisit: pageFlags.connectionList };
};

const actions = {
  togglePageFlag,
  onCopyAndConnect: copyAndConnect,
  onConnectEntities: connectEntities,
  onUnlink: unlink
};

export default connect(mapStateToProps, actions)(ConnectionList);
